<div
  class="bg-white rounded-10 p-4 text-blue text-14 max-sm:text-12 font-roboto-400"
>
  <div class="flex justify-between px-2 mb-2">
    <div class="text-20">{{ "terms title" | translate }}</div>
    <img
      alt="logo"
      class="w-[150px] object-contain"
      [src]="urlIMG + 'logo-red.png'"
    />
  </div>
  <nz-divider></nz-divider>

  <div *ngFor="let term of terms; let termIndex = index" class="mb-4">
    <div class="font-roboto-600 text-15">
      {{ termIndex + 1 }}. {{ term.header | translate }}
    </div>
    <div class="ml-4">
      <div
        *ngFor="let point of term.points; let pointIndex = index"
        class="mb-2"
      >
        <div class="font-roboto-500">
          {{ termIndex + 1 }}.{{ pointIndex + 1 }}.
          {{ point.header | translate }}
        </div>
        <p
          class="flex"
          [innerHTML]="point.text | translate"
          class="text-gray-700"
        ></p>
      </div>
    </div>
  </div>
</div>
